import { GbValidators } from 'libs/shared/utils/helpers/src/lib/gb-validators/gb-validators'
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { UsersFacade } from '@galabid/gb-dashboard/user/data-access'
import * as UsersActions from 'libs/gb-dashboard/user/data-access/src/lib/+state/users.actions'
import { USERS_LOADER } from '../../../../data-access/src/lib/+state/users.models'
@Component({
  selector: 'gb-change-user-password',
  templateUrl: './gb-change-user-password.component.html',
  styleUrls: ['./gb-change-user-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbChangeUserPasswordComponent {
  changePasswordLoaded$ = this.usersFacade.changePasswordLoaded$
  changePasswordFormFields = {
    new_password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirm_password: new FormControl('', Validators.required),
  }
  changePasswordForm = new FormGroup(
    this.changePasswordFormFields,
    Validators.compose([GbValidators.mustMatch('new_password', 'confirm_password')]),
  )

  get new_password() {
    return this.changePasswordForm.get('new_password')
  }
  get confirm_password() {
    return this.changePasswordForm.get('confirm_password')
  }

  dialogData: { user: string; uuid: string }

  constructor(
    private usersFacade: UsersFacade,

    @Inject(MAT_DIALOG_DATA)
    data: {
      user: string
      uuid: string
    },
  ) {
    this.dialogData = data
  }

  submitForm() {
    this.changePasswordForm.valid ? this.submitUpdate() : this.onError()
  }

  onError() {
    this.changePasswordForm.markAllAsTouched()
  }

  submitUpdate() {
    if (this.new_password?.value && this.confirm_password?.value)
      this.usersFacade.dispatch(
        UsersActions.changePassword({
          new_password: this.new_password?.value as string,
          confirm_password: this.confirm_password?.value as string,
          user: this.dialogData.user,
        }),
      )
  }

  back() {
    this.usersFacade.dispatch(UsersActions.openEditUserDialog({ uuid: this.dialogData.uuid }))
  }

  protected readonly USERS_LOADER = USERS_LOADER
}
